import { combineReducers } from "redux";

import { isLoaderReducer } from "./isLoaderReducer/isLoaderReducer";
import { userReducer } from "./userReducer/userReducer";
import { userInfoReducer } from "./userInfoReducer/userInfoReducer";
import { menuReducer } from "./menuReducer/menuReducer";
import { timerReducer } from "./timerReducer/timerReducer";

export const reducers = combineReducers({
  isLoader: isLoaderReducer,
  user: userReducer,
  userInfo: userInfoReducer,
  isOpenMenu: menuReducer,
  timerStatus: timerReducer,
});
